export interface IApplication {
    id?: string | undefined;
    // The raw application _id from the API. `id` can be SHA256(_id), which
    // tracking can never join back to the applications collection.
    trackingApplicationId?: string | undefined;
    applicationId?: string | undefined;
    isDeclined?: boolean | undefined;
    declineReason?: string | undefined;
    isServicing?: boolean | undefined;
    isPreApproved?: boolean | undefined;
    isSubmitted?: boolean | undefined;
    skynetOpportunityId?: string | undefined;
    DIFBrokerPhoneNumber?: string | undefined;
    skynetPartnerId?: string | undefined;
    progressPercent?: number | undefined;
    partnerOverwriteId: string | null;
    correlationId?: string | undefined;
    // Marketing attribution from the landing URL (SR-2784). Sent to the API inside
    // the borrower slice on save, where it is sanitised and stored once.
    attribution?: IApplicationAttribution | undefined;
    storeSelector?: {
        storeOptionsId: string;
        selectedStoreId: string;
    }[];
}

export const initialApplication: IApplication = {
    partnerOverwriteId: null,
    correlationId: undefined,
    attribution: undefined,
};

export interface IApplicationUtm {
    source?: string;
    medium?: string;
    campaign?: string;
    content?: string;
    term?: string;
    id?: string;
}

export interface IApplicationAttribution {
    utm?: IApplicationUtm;
    clickIds?: {
        gclid?: string;
    };
}
